<template>
    <div class="popular">
        <ProductPopup
            :product_data = "selectedProduct"
            v-if="isPopupOpened"
            @closePopup="closePopup"/>

        <div class="catalog-notification">
            <CartNotification :messages="messages"/>
        </div>

        <div class="popular__inner container">
            <h1 class="popular__heading heading">популярные букеты</h1>
            <div class="cart-additional__slider slider">
                    <div class="swiper-button-prev"></div>
                    <div class="swiper-button-next"></div>
                
                <swiper
                    :slidesPerView="slides"
                    :space-between="15"
                    :modules="modules"
                    :freeMode="isFree"
                    :navigation="{
                                prevEl: '.swiper-button-prev',
                                nextEl: '.swiper-button-next', 
                            }"
                    @swiper="onSwiper"
                    @slideChange="onSlideChange"
                    class="main-slider"
                    >
                    <swiper-slide 
                        v-for="flower in POPULAR_FLOWERS"
                        :key="flower.id"
                        class="main-slider__slide main-slide">
                        <CatalogItem 
                            :product_data="flower"
                            class="slider__item"
                            @addToCart="addToCart"
                            @showProduct="showProduct"/>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import CatalogItem from '@/components/Additional-product'
import ProductPopup from '@/components/Product-popup'
import CartNotification from '@/components/Cart-notification';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation, Pagination, Scrollbar, A11y, FreeMode} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { ref } from 'vue';

export default {
    data() {
        return {
            isFree: false,
            slides: 3,
            selectedProduct: '',
            isPopupOpened: false,
            messages: []
        }
    },
    setup() {
        const onSwiper = (swiper) => {

        };
        const onSlideChange = () => {

        };
        const prev = ref(null);
        const next = ref(null);
        return {
            onSwiper,
            onSlideChange,
            modules: [Navigation, Pagination, Scrollbar, A11y, FreeMode],
            prev,
            next
        };
    },
    components: {
        Swiper,
        SwiperSlide,
        CatalogItem,
        ProductPopup,
        CartNotification
    },
    computed: {
        ...mapGetters([
            'POPULAR_FLOWERS'
        ])
    },
    methods: {
        ...mapActions([
            'GET_POPULAR_PRODUCTS'
        ]),
        showProduct(data){
            this.selectedProduct = data
            this.isPopupOpened = true
            document.body.style.overflowY = 'hidden'
        },
        closePopup(){
            this.isPopupOpened = false
            document.body.style.overflowY = 'scroll'
        },
        addToCart(){
            let timeStamp = Date.now().toLocaleString()
            this.messages.unshift(
                {name: "Товар добавлен в корзину", id: timeStamp}
            )
        },
    },
    beforeMount() {
        if(window.screen.width <= 768){
            this.isFree = true
            this.slides = 'auto'
        }
    },
    mounted() {
        this.GET_POPULAR_PRODUCTS()
    },
}
</script>

<style scoped>
    .main-slider{
        width: 100%;
    }
    .cart-additional__slider{
        display: flex;
        position: relative;
        padding-right: 20px;
        padding-left: 20px;
    }
    .popular__heading{
        margin-bottom: 30px;
    }
    .swiper-button-prev{
        color: #000;
        left: -20px;
        transition: all linear .2s;
        background: url(../images/icons/arrow.svg) no-repeat;
        transform: rotate(180deg);
        height: 30px;
        width: 18px;
    }
    .swiper-button-next{
        color: #000;
        right: -20px;
        transition: all linear .2s;
        background: url(../images/icons/arrow.svg) no-repeat;
        height: 30px;
        width: 18px;
    }
    .swiper-button-next::after{
        display: none;
    }
    .swiper-button-prev::after{
        display: none;
    }
    .swiper-button-prev:hover{
        opacity: .5;
    }
    .swiper-button-next:hover{
        opacity: .5;
    }
    .slider__item{
        width: 100%;
    }
    @media (max-width: 768px) {
        .main-slider{
            width: 100%;
        }
        .swiper-button-prev{
            display: none;
        }
        .swiper-button-next{
            display: none;
        }
        .cart-additional__slider{
            padding-left: 0;
            padding-right: 0;
            /* overflow: hidden; */
        }
        .main-slider__slide{
            display: flex;
            justify-content: center;
            align-items: center;
            min-width: 210px;
            max-width: 210px;
            margin-right: 20px;
        }
    }
    @media (max-width: 600px){
        .popular__heading{
            margin-bottom: 25px;
        }
    }
</style>